import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id              : 0,
        user_id                 : 0,
        project_id              : 0,
        name                    : '',
        access_key              : '',
        create_time             : 0
    }
});